module.exports = __webpack_public_path__ + "img/enlarge-t.4c93f69e.svg";